/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="18"
        height="12"
        viewBox="0 0 18 12"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M0 12h18V0H0Zm1.54-.95 4.41-4.9 3.13 2.87 3-2.82 4.36 4.85Zm15.51-.76-4.27-4.74 4.27-4ZM16.32.95 9.07 7.72 1.7.95ZM.95 1.56l4.3 3.95-4.3 4.78Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'EnvelopeIcon';

export default Icon;
